import React from "react";
import { styled } from "@mui/system";
import Button from "@mui/material/Button";

import { ReactComponent as Loader } from "./../../assets/icons/loader.svg";
import { theme } from "../../theme";
import { ICONS, Icon } from "../Icons";

const styles = {
  "&.MuiButton-root": {
    minHeight: "50px",
    outline: "none ",
    fontSize: "1rem",
    textTransform: "none",
    padding: "16px 40px",
    backgroundColor: "#000",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.7)"
    },
    "&:disabled": {
      backgroundColor: "#757575"
    },

    "> .labelStyle": {
      fontSize: "1rem",
      lineHeight: "20px",
      textAlign: "left",
      color: "#ffffff",
      justifyContent: "space-between",
      textTransform: "none",
      [theme.breakpoints.only("sm")]: {
        fontSize: "1.125rem",
        lineHeight: "20px"
      },

      [theme.breakpoints.up("md")]: {
        fontSize: "1.25rem",
        lineHeight: "28px",
        textAlign: "left",
        color: "#ffffff",
        justifyContent: "space-between",
        textTransform: "none"
      }
    },
    "> .btnLoader": {
      width: "20px",
      height: "20px"
    },
    [theme.breakpoints.only("md")]: {
      fontSize: "1.125rem",
      padding: "12px 30px",
      lineHeight: "20px"
    },

    [theme.breakpoints.up("lg")]: {
      fontSize: "1.25rem",
      padding: "12px 45px"
    }
  },
  "@keyframes rotate": {
    "100%": {
      transform: "rotate(360deg)"
    }
  }
};

const BaseButton = ({
  variant = "contained",
  label = "",
  type = "button",
  disabled = false,
  className,
  handleClick,
  color = "primary",
  component = "button",
  withRightArrow,
  isSearchApplicant,
  isDisplayLoader,
  classes,
  name,
  ...props
}) => (
  <Button
    variant={variant}
    component={component}
    color={color}
    type={type}
    className={`${className} ${classes?.buttonStyle}`}
    disabled={isDisplayLoader || disabled}
    onClick={handleClick}
    name={name}
    data-testid="contained-button"
    {...props}
  >
    {isDisplayLoader ? (
      <Loader alt="loading" className="btnLoader" data-testid="loader" />
    ) : (
      [
        <span key={"LABEL" + name} className={`${classes?.labelStyle} labelStyle`}>
          {label}
        </span>,
        withRightArrow && (
          <Icon
            sx={{
              fill: isSearchApplicant ? "#000" : "#FFF",
              width: "12px",
              height: "10px",
              verticalAlign: "top",
              marginLeft: "8px"
            }}
            alt="rightArrowWhite"
            name={ICONS.arrowRight}
            key={"KEY" + name}
          />
        )
      ]
    )}
  </Button>
);

export const ContainedButton = styled(BaseButton)(styles);
